<template>
  <v-navigation-drawer
    :clipped="$vuetify.breakpoint.lgAndUp"
    :mini-variant="mini"
    fixed
    app
    permanent
    mini-variant-width="55"
    width="180"
    class="ContSidebar"
  >
    <v-layout
      column
      style="height: 100%">
      <div class="py-2 pr-2">
        <v-layout
          align-center
          class="ma-0">
          <v-icon
            class="ml-3"
            small
            @click="mini=!mini">menu</v-icon>
          <template v-if="!mini">
            <div class="title pl-2">
              {{ user.nickname }}
            </div>
            <v-spacer />
            <a @click="logout">登出</a>
          </template>
        </v-layout>
      </div>
      <v-divider />
      <v-list dense>
        <v-list-tile
          v-if="user.role == 9"
          :to="{ name: 'SupplementTariff' }">
          <v-icon small>edit</v-icon>
          <v-list-tile-content>
            <v-list-tile-title
              class="pl-2"
              style="overflow: visible">
              品名審核
              <span
                v-if="hasSupplementTariffPending"
                class="has-data"/>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <template v-if="user.role == '5'">
          <v-list-tile :to="{ name: 'JybParcel' }">
            <v-icon small>image</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">面單破損查詢</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="{ name: 'JybSubtnoSelfDelivery' }">
            <v-icon small>local_shipping</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">自派件包裹</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <template v-else-if="user.role == '6'">
          <v-list-tile :to="{ name: 'JybSubtnoSea' }">
            <v-icon small>local_shipping</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">海運包裹</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <template v-else>
          <!-- 3 报关行用户 9 报送行 -->
          <v-list-tile :to="{ name: 'Duty' }">
            <v-icon small>picture_as_pdf</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">稅單查詢</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'DutySearchMutil', query: {type: 'searchMutil'} }"
            target="_blank">
            <v-icon small>picture_as_pdf</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">稅單批量查詢</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="userProfile.hasFtzehu"
            :to="{ name: 'Report', params: { source: 'ftze' } }">
            <i class="iconfont iconfeiji1"/>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">驗放報告</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="userProfile.hasFtzehu"
            :to="{ name: 'Goodscc', params: { source: 'ftze' } }">
            <i class="iconfont iconfeiji1"/>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2"> 清關報告</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="userProfile.hasTaipeiPort"
            :to="{ name: 'Report', params: { source: 'taip' } }">
            <i class="iconfont iconchuan"/>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">驗放報告</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="userProfile.hasTaipeiPort"
            :to="{ name: 'Goodscc', params: { source: 'taip' } }">
            <i class="iconfont iconchuan"/>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">清關報告</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- <v-list-tile
        :to="{name: 'Home'}"
      >
        <v-list-tile-content>
          <v-list-tile-title>清關報告</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile> -->
          <v-list-tile
            :to="{ name: 'TradevanValidate' }">
            <v-icon small>verified_user</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">驗證易利委實名</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="canManagePasswords"
            :to="{ name: 'AccountSettings' }">
            <v-icon small>settings</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">帳號設定</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'AuthPreApntd' }">
            <v-icon small>verified_user</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">預先委任查詢</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-if="user.role == '8'"
            :to="{ name: 'User' }">
            <v-icon small>group</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">客戶帳戶管理</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-if="user.role == '3'"
            :to="{ name: 'ClearanceRecordListDownload' }">
            <v-icon small>file_download</v-icon>
            <v-list-tile-content>
              <v-list-tile-title
                class="pl-2"
                style="overflow: visible">
                簡易報單下載
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <template v-if="user.role == '9'">
            <v-list-tile
              :to="{ name: 'JybPushnsPreApntd' }">
              <v-icon small>notifications</v-icon>
              <v-list-tile-content>
                <v-list-tile-title class="pl-2"><b>通知客人確認相符</b></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              :to="{ name: 'JybPushnsTvUnverified' }">
              <v-icon small>notifications</v-icon>
              <v-list-tile-content>
                <v-list-tile-title class="pl-2"><b>通知未實名/姓名不符</b></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              :to="{ name: 'BrokerReply' }">
              <v-icon small>remove_circle_outline</v-icon>
              <v-list-tile-content>
                <v-list-tile-title class="pl-2">申報不符</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              :to="{ name: 'ProbTags' }">
              <v-icon small>done</v-icon>
              <v-list-tile-content>
                <v-list-tile-title class="pl-2">已結案</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              :to="{ name: 'PapersG1List' }">
              <v-icon small>receipt</v-icon>
              <v-list-tile-content>
                <v-list-tile-title class="pl-2">
                  G1正式報關
                  <span
                    v-if="g1PaperListHasPending"
                    class="has-data"/>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- <v-list-tile
          :to="{ name: 'PapersPapers' }">
          <v-icon small>receipt</v-icon>
          <v-list-tile-content>
            <v-list-tile-title class="pl-2">報關資料</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
            <v-list-tile
              v-if="user.role == '9'|| user.uid == '100129'"
              :to="{ name: 'ReportDeclFileList' }">
              <v-icon small>list</v-icon>
              <v-list-tile-content>
                <v-list-tile-title
                  class="pl-2"
                  style="overflow: visible">
                  未上传報關單
                  <span
                    v-if="hasDeclFile"
                    class="has-data"/>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="user.role == '9'"
              :to="{ name: 'ClearanceRecordListUpload' }">
              <v-icon small>upload</v-icon>
              <v-list-tile-content>
                <v-list-tile-title
                  class="pl-2"
                  style="overflow: visible">
                  簡易報單上拋
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- v-if="user.label == 'huah' || user.label == 'xyun' || user.label == 'liandi' || user.label == 'dfeng' || user.label == 'dong' || user.label == 'zxin' || user.label == 'zxintz' || user.label == 'yuguan' || user.label == 'all'" -->
            <v-list-tile
              v-if="user.label == 'all' || user.role==9 || user.label == 'dfeng'"
              :to="{ name: 'NotDutyFile' }">
              <v-icon small>picture_as_pdf</v-icon>
              <v-list-tile-content>
                <v-list-tile-title
                  class="pl-2"
                  style="overflow: visible">
                  未上传稅單
                  <span
                    v-if="hasNotDutyFile"
                    class="has-data"/>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="user.role == '9'"
              :to="{ name: 'User' }">
              <v-icon small>group</v-icon>
              <v-list-tile-content>
                <v-list-tile-title class="pl-2">客戶帳戶管理</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              :to="{ name: 'JybParcel' }">
              <v-icon small>image</v-icon>
              <v-list-tile-content>
                <v-list-tile-title class="pl-2">面單破損查詢</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              :to="{ name: 'Ccfile' }">
              <v-icon small>fact_check</v-icon>
              <v-list-tile-content>
                <v-list-tile-title class="pl-2">清關資料校驗</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </template>
      </v-list>

      <v-spacer />
      <!-- <v-list-tile
        v-if="user.role == '9'"
        href="https://jyb-pda-update.oss-cn-hongkong.aliyuncs.com/setup/tradevan_boxed.exe"
        target="_blank"
      >
        <v-list-tile-content>
          <v-list-tile-title>稅單軟體</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile> -->
      <template v-if="user.role == '9'">
        <v-divider />
        <!-- <v-list
          dense
          class="py-2">
          <v-list-tile
            v-if="user.role == '9'"
            href="https://jyb-pda-update.oss-cn-hongkong.aliyuncs.com/setup/tradevan_boxed.exe"
            target="_blank"
          >
            <v-icon>file_download</v-icon>
            <v-list-tile-content>
              <v-list-tile-title class="pl-2">稅單軟體</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list> -->
        <CrxCard/>
      </template>

      <Schedule
        :interval="1000*60*10"
        @exec="fetchG1PaperList"
      />
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import dayjs from 'dayjs'
import CrxCard from './CrxCard'
import Schedule from '@/components/Schedule'
import { canManageAccountPasswords } from '@/utils/permissions'

/**
 * role 3 报关行用户 9 报送行 8 清关管理（非巧巧郞合并的清关行）
 */
export default {
  name: 'ContSidebar',
  components: {
    CrxCard,
    Schedule,
  },
  props: {
    isSidebarMini: {
      type: null,
    },
  },
  data () {
    return {
      currentPath: true,
      userProfile: {
        // hasFtzehu: 1,  是否設置了遠雄倉賬號（清關空運）
        // hasTaipeiPort: 0,  是否設置了東力倉賬號（清關海運海快）
        // hasTradevanTdis: 1,  是否設置了關貿賬號（查稅單）
        // hasNatswPortal: 1  是否設置了單一窗口賬號（查稅單）
      },
      mini: false,
      hasDeclFile: false,
      hasNotDutyFile: false,
      hasSupplementTariffPending: false,
    }
  },
  computed: {
    user () {
      return this.$store.state.user.info
    },
    canManagePasswords () {
      return canManageAccountPasswords(this.user)
    },
    isMini: {
      get () {
        return this.isSidebarMini
      },
      set (newValue) {
        this.$emit('update:isSidebarMini', newValue)
      },
    },
    getSideMenus () {
      return this.$store.state.sideMenus
    },
    g1PaperListHasPending () {
      return !!this.$store.state.cc.goodscc.g1PaperList.find(item => item.pending)
    }
  },
  watch: {
    'user.role': {
      immediate: true,
      handler (role) {
        if (String(role) === '9') {
          this.hasSupplementTariff()
          return
        }
        this.hasSupplementTariffPending = false
      },
    },
  },
  mounted () {
    this.fetchUserProfile()
    this.notHasDeclFile()
    this.notHasDutyFile()
  },
  methods: {
    isMenuActive (menuRoute) {
      return this.$route.path.indexOf(menuRoute) === 0
    },
    logout () {
      if (confirm('請確認登出！')) {
        this.$store.dispatch('user/logout')
      }
    },
    fetchG1PaperList () {
      this.$store.dispatch('cc/goodscc/searchX3G1', {
        updatedDateStart: dayjs().add(-15, 'day').format('YYYY-MM-DD'),
        updatedDateEnd: dayjs().format('YYYY-MM-DD'),
        page: 500,
        pageSize: 1,
      })
    },
    async fetchUserProfile () {
      const res = await this.$store.dispatch('cc/userProfile')
      if (!res.data.error) {
        this.userProfile = res.data.model
      }
    },
    async notHasDeclFile () {
      const res = await this.$store.dispatch('cc/synchro/searchX3g1Group', {
        cdateStart: dayjs().add(-60, 'day').format('YYYY-MM-DD'),
        cdateEnd: dayjs().format('YYYY-MM-DD'),
        hasDeclFile: 'N',
        pageSize: 1,
      })
      this.hasDeclFile = res.data.list.length > 0
    },
    async notHasDutyFile () {
      const res = await this.$store.dispatch('cc/synchro/searchX3g1Group', {
        cdateStart: dayjs().add(-60, 'day').format('YYYY-MM-DD'),
        cdateEnd: dayjs().format('YYYY-MM-DD'),
        hasDutyFile: 'N',
        pageSize: 1,
      })
      this.hasNotDutyFile = res.data.list.length > 0
    },
    async hasSupplementTariff () {
      if (String(this.user.role) !== '9') return

      try {
        const res = await this.$store.dispatch('tpHscodeCca/search', {
          page: 1,
          pageSize: 1,
        })
        this.hasSupplementTariffPending = !res.data.error && res.data.list.length > 0
      } catch (error) {
        this.hasSupplementTariffPending = false
      }
    },
  },
}
</script>
<style lang="postcss" scoped>
.iconfont {
  color: rgba(0,0,0,.54);
}
.has-data {
  position: relative;
  display: inline-block;
  width: 8px;
  height: 8px;
  top: -8px;
  background: red;
  border-radius: 100%;
}
</style>
<style lang="postcss">
.ContSidebar .v-list__tile--active {
 i {
   color: inherit;
 }
}
</style>



// WEBPACK FOOTER //
// src/views/_layout/ContSidebar.vue